'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = _interopDefault(require('react'));
var PropTypes = _interopDefault(require('prop-types'));
var styled = _interopDefault(require('styled-components'));
var reactSpring = require('react-spring');

// Default opacity to fade to and out of; can be changed by style prop.
var DEFAULT_OPACITY = '0.3';
var Container = styled.div.withConfig({
  componentId: "ny6hv6-0"
})(["overflow:hidden;position:fixed;top:0;right:0;bottom:0;left:0;z-index:999;background-color:", ";"], function (props) {
  return props.s.backgroundColor || '#000';
});
var Overlay = function Overlay(_ref) {
  var show = _ref.show,
    onClick = _ref.onClick,
    style = _ref.style;
  var transitions = reactSpring.useTransition(show, null, {
    config: {
      duration: 200,
      mass: 1,
      tension: 500,
      friction: 1,
      clamp: true
    },
    from: {
      opacity: '0'
    },
    enter: {
      opacity: typeof style.opacity === 'undefined' ? DEFAULT_OPACITY : "".concat(style.opacity)
    },
    leave: {
      opacity: '0'
    }
  });
  return transitions.map(function (_ref2) {
    var item = _ref2.item,
      key = _ref2.key,
      props = _ref2.props;
    return item && /*#__PURE__*/React.createElement(reactSpring.animated.div, {
      key: key,
      style: props
    }, /*#__PURE__*/React.createElement(Container, {
      onClick: onClick,
      s: style
    }));
  });
};
Overlay.defaultProps = {
  show: false,
  style: {}
};
Overlay.propTypes = {
  show: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  style: PropTypes.shape({
    opacity: PropTypes.number,
    backgroundColor: PropTypes.string
  })
};

exports.default = Overlay;
